import { cn } from '../../lib/utils.js';

const variants = {
  default: 'bg-gray-100 text-gray-800',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  brand: 'bg-brand-100 text-brand-800',
};

type Variant = keyof typeof variants;

interface BadgeProps {
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}

export function statusBadge(status: string) {
  const map: Record<string, Variant> = {
    applied: 'success',
    published: 'success',
    approved: 'success',
    pending_review: 'warning',
    pending: 'warning',
    conflict: 'warning',
    needs_review: 'warning',
    failed: 'error',
    blocked: 'error',
    applying: 'info',
    parsing: 'info',
    resolving: 'info',
    validating: 'info',
    diffing: 'info',
    uploading: 'info',
    create: 'brand',
    update: 'info',
    no_op: 'default',
    skipped: 'default',
  };
  return map[status] ?? 'default';
}
